import DTReinstateAccountThenSendMacro from '../NodeGroups/DTCopyTextSendMacro/DTReinstateAccountThenSendMacro/DTReinstateAccountThenSendMacro';
import { getShowConfirmationPage } from '../../../selectors/tools';
import { useSelector } from 'react-redux';

const ReinstateAccountThenSendMacro = () => {
  const showConfirmationPage = useSelector(getShowConfirmationPage);

  return (
    <DTReinstateAccountThenSendMacro
      showConfirmation={showConfirmationPage}
      message={'The account has been reinstated'}
    />
  );
};

export default ReinstateAccountThenSendMacro;
